export default {
  state: () => ({
    permited: false,
    kind: null,
    is_auction: false,
    origin_id: null,
    dealer_id: null,
    seller_id: null,
    engine_score: null,
    gearbox_score: null,
    final_judgment: null,
    body_damage: null,
    bodywork_damage_severity: null,
    damage_category_id: null,
    damage_range_label: null,
    body_damage_description: null,
    tire_score: null,
    tire_description: null,
    has_spare_key: null,
    has_manual: null,
    has_factory_warranty: null,
    dealer_maintenance: null,
    maintenance_history_status: null,
    technical_data_version: null,
    note: null,
    value: null,
    value_addition: null,
    publication_price: null,
    customer_minimum_price: null,
    value_bonus: null,
    trading_value: null,
    note_id: null,
    destination: null,
  }),
  mutations: {
    setIsHourAuction(state, payload) {
      state.is_auction = payload;
    },
    setDestination(state, payload) {
      state.destination = payload;
    },
    setValue(state, payload) {
      state.value = payload;
    },
    setValueAddition(state, payload) {
      state.value_addition = payload;
    },
    setPublicationPrice(state, payload) {
      state.publication_price = payload;
    },
    setCustomerMinimumPrice(state, payload) {
      state.customer_minimum_price = payload;
    },
    setValueBonus(state, payload) {
      state.value_bonus = payload;
    },
    setTradingValue(state, payload) {
      state.trading_value = payload;
    },
    setPermited(state, payload) {
      state.permited = payload;
    },
    setKind(state, payload) {
      state.kind = payload;
    },
    setOriginId(state, payload) {
      state.origin_id = payload;
    },
    setDealerId(state, payload) {
      state.dealer_id = payload;
    },
    setSellerId(state, payload) {
      state.seller_id = payload;
    },
    setEngineScore(state, payload) {
      state.engine_score = payload;
    },
    setGearboxScore(state, payload) {
      state.gearbox_score = payload;
    },
    setBodyDamage(state, payload) { state.body_damage = payload; },
    setBodyworkDamageSeverity(state, payload) { state.bodywork_damage_severity = payload; },
    setDamageCategoryId(state, payload) { state.damage_category_id = payload; },
    setBodyDamageDescription(state, payload) { state.body_damage_description = payload; },
    setTireScore(state, payload) { state.tire_score = payload; },
    setTireDescription(state, payload) { state.tire_description = payload; },
    setHasSpareKey(state, payload) { state.has_spare_key = payload; },
    setHasManual(state, payload) { state.has_manual = payload; },
    setHasFactoryWarranty(state, payload) { state.has_factory_warranty = payload; },
    setDealerMaintenance(state, payload) { state.dealer_maintenance = payload; },
    setMaintenanceHistoryStatus(state, payload) { state.maintenance_history_status = payload; },
    setNote(state, payload) {
      state.note = payload;
    },
    setNoteId(state, payload) {
      state.note_id = payload;
    },
    setEvaluationForm(state, payload) {
      state.permited = true;
      state.kind = payload.kind;
      state.origin_id = payload.origin_id;
      state.dealer_id = payload.dealer_id;
      state.seller_id = payload.seller_id;
      state.engine_score = payload.engine_score;
      state.is_auction = payload.is_auction;
      state.gearbox_score = payload.gearbox_score;
      state.final_judgment = payload.final_judgment;
      state.body_damage = payload.body_damage;
      state.bodywork_damage_severity = payload.bodywork_damage_severity;
      state.damage_category_id = payload.damage_category_id;
      state.damage_range_label = payload.damage_range_label;
      state.body_damage_description = payload.body_damage_description;
      state.tire_score = payload.tire_score;
      state.tire_description = payload.tire_description;
      state.has_spare_key = payload.has_spare_key;
      state.has_manual = payload.has_manual;
      state.has_factory_warranty = payload.has_factory_warranty;
      state.dealer_maintenance = payload.dealer_maintenance;
      state.maintenance_history_status = payload.maintenance_history_status;
      state.technical_data_version = payload.technical_data_version;
      state.note = payload.note;
      state.note_id = payload.note_id;

      if (payload.destination) {
        state.destination = payload.destination;
      }

      if (payload.trading_value) {
        state.trading_value = payload.trading_value;
      }

      if (payload.value) {
        state.value = payload.value;
      }

      if (payload.value_addition) {
        state.value_addition = payload.value_addition;
      }

      if (payload.publication_price) {
        state.publication_price = payload.publication_price;
      }

      if (payload.customer_minimum_price) {
        state.customer_minimum_price = payload.customer_minimum_price;
      }

      if (payload.value_bonus) {
        state.value_bonus = payload.value_bonus;
      }
    },
  },
  actions: {},
};
